import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getInvestmentDetailsBankInformation } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service.ts';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams.ts';

export const useInvestmentDetailsBankInformation = () => {
	const { mipId, investmentId } = useRequiredParams('mipId', 'investmentId');
	const query = useQuery({
		queryKey: [
			API_PATHS.MIP_MIPID_INVESTOR_INVESTMENT_WORKFLOW_INVESTMENT_DETAILS_INVESTMENTID_BANK_INFORMATION_GET,
			mipId,
			investmentId,
		],
		queryFn: () => getInvestmentDetailsBankInformation(mipId, investmentId),
	});

	return {
		data: query.data?.payload,
		isLoading: query.isLoading,
		isError: query.isError,
		refetch: query.refetch,
	};
};
